import React, { useContext } from "react";
import QWrapper from "./QWrapper.js";
import QTitle from "./QTitle.js";
import LanguageContext from "../contexts/languageContext.js";
import I18N from "./I18N.js";

const SelectOneQuestion = ({
  label,
  options,
  id,
  readyToSubmit,
  needsAttention,
  handler,
  formState,
}) => {
  const { language, defaultLanguage } = useContext(LanguageContext);
  const { rtl } = useContext(LanguageContext);

  return (
    <QWrapper key={id}>
      <QTitle>{label[language]}</QTitle>

      <div className="form-floating">
        <select
          onChange={(e) => {
            handler(id, e.target.value);
          }}
          defaultValue={
            formState.hasOwnProperty(id) && formState[id] ? formState[id] : null
          }
          className={`form-select  py-2 border border ${
            rtl ? "text-end " : "text-start"
          }
          ${
            readyToSubmit
              ? "border-success bg-success bg-opacity-10"
              : needsAttention
              ? "border-danger bg-danger bg-opacity-10"
              : ""
          }`}
          aria-label="Select Language"
        >
          <option className="text-center" value={""}>
            {I18N("please_select", language)}
          </option>
          {options[language].map((o, i) => (
            <option
              key={i}
              value={options[defaultLanguage][i]}
              className={rtl ? "text-end" : "text-start"}
            >
              {o}
            </option>
          ))}
        </select>
      </div>
    </QWrapper>
  );
};

export default SelectOneQuestion;
